<template>
    <div :class="`animated ${showNoteForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`">
        <FormSection :application-id="application" :showBackground="false">
            <template #content>
                <div class="p-3">
                    <div class="form-group col-6">
                        <label for="title">
                            Title
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            class="form-control"
                            name="title"
                            type="text"
                            placeholder="Enter Title"
                            v-model="note.title"
                            :disabled="isReadOnly"
                            maxlength="50"
                        />
                    </div>
                    <div class="form-group col-12">
                        <label for="notes">
                            Notes
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <textarea
                            class="form-control"
                            name="notes"
                            type="text"
                            placeholder="Enter Preadmission Notes"
                            v-model="note.notes"
                            :disabled="isReadOnly"
                            maxlength="2000"
                        >
                        </textarea>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <button type="button" class="btn btn-outline-primary mb-2" @click="closeNoteForm()">Close</button>
                </div>
            </template>
        </FormSection>
    </div>
</template>

<script lang="ts" src="./PreadmissionNotesForm.ts"></script>
